module.exports = __webpack_public_path__ + "img/mb_footer_bg.c877709.webp";